import React from "react";
import "./index.css";

const steps = [
  { num: "1", text: "Find your perfect puppy" },
  { num: "2", text: "Reserve & pick delivery" },
  { num: "3", text: "Health & readiness check" },
  { num: "4", text: "Delivery coordination & arrival" },
  { num: "5", text: "Support for life" },
];

const HowItWorks: React.FC = () => {
  return (
    <section className="hiw-section">
      {/* Header */}
      <div className="hiw-header">
        <h2 className="hiw-title">How it Works</h2>
        <p className="hiw-subtitle">
          Five simple steps to unconditional puppy love
        </p>
      </div>

      {/* Steps */}
      <div className="hiw-steps">
        {steps.map(({ num, text }) => (
          <div className="hiw-step" key={num}>
            <span className="hiw-step-num">{num}</span>
            <span className="hiw-step-text">{text}</span>
          </div>
        ))}
      </div>

      {/* Button */}
      <a href="/how-it-works" className="hiw-button">
        Learn about our process
      </a>
    </section>
  );
};

export default HowItWorks;
